const NAMESPACES = /** @type {const} */ ({
  AUTH: 'auth',
  COMMON: 'common',
  COMMUNITY: 'community',
  HOME: 'home',
  INTENTION: 'intention',
  PRAY: 'pray',
  SHARE: 'share',
  TAG: 'tag',
  USER: 'user',
})

module.exports = { NAMESPACES }
